import { render, staticRenderFns } from "./WishList.vue?vue&type=template&id=b4754038&"
import script from "./WishList.vue?vue&type=script&lang=js&"
export * from "./WishList.vue?vue&type=script&lang=js&"
import style0 from "./WishList.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports